import type { LiteUserOut } from '@repo/api-codegen';
import { Banner } from '@repo/foundations';
import { AiViewportWrapper } from './AiViewportWrapper';

export function SharedChatBanner({ user }: { user: LiteUserOut }) {
	return (
		<AiViewportWrapper>
			<Banner
				tone="neutral"
				message={`You are viewing a conversation between Secoda AI and ${user.display_name ?? 'a team member'}.`}
			/>
		</AiViewportWrapper>
	);
}
